import { type PropsWithChildren } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { Trans, useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { CMS_CDN } from '@/consts/env';
import { useLocale } from '@/hooks';
import { ArrowRightIcon } from '@/icons';
import { Button } from '@/ui_v3';
export const Review = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  const {
    locale
  } = useLocale();
  const REVIEWS = [{
    name: t('landing.review1.name'),
    from: t('landing.review1.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/Wk5/lKUY83wK87duEDAq2XzFWk5/en-US/1/profile1.webp`,
    content: <Trans t={t} i18nKey="landing.review1.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review2.nameV2'),
    from: t('landing.review2.fromV2'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/QFZ/I4bA93wK87cuEDAq2TZhQFZ/en-US/1/profile2.webp`,
    content: <Trans t={t} i18nKey="landing.review2.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review3.name'),
    from: t('landing.review3.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/Y4y/m1Xfc3wK87duEDAq2YhSY4y/en-US/1/profile3.webp`,
    content: <Trans t={t} i18nKey="landing.review3.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review4.name'),
    from: t('landing.review4.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/bP3/C1EgY3wK87duEDAq2HRLbP3/en-US/1/profile4.webp`,
    content: <Trans t={t} i18nKey="landing.review4.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review5.name'),
    from: t('landing.review5.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/OTB/TOgHS3wK87cuEDAvNMCWOTB/en-US/1/profile5.webp`,
    content: <Trans t={t} i18nKey="landing.review5.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review6.name'),
    from: t('landing.review6.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/EXY/6UFDC3wK87duEDAvNKzPEXY/en-US/1/profile6.webp`,
    content: <Trans t={t} i18nKey="landing.review6.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review7.name'),
    from: t('landing.review7.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/sR1/htyUS3wK87duEDAvNKo4sR1/en-US/1/profile7.webp`,
    content: <Trans t={t} i18nKey="landing.review7.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review8.name'),
    from: t('landing.review8.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/0uy/N2cMu3wK87cuEDAvNNuC0uy/en-US/1/profile8.webp`,
    content: <Trans t={t} i18nKey="landing.review8.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review9.name'),
    from: t('landing.review9.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/sE7/diLbK3wK87cuEDAvNM5osE7/en-US/1/profile9.webp`,
    content: <Trans t={t} i18nKey="landing.review9.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review10.nameV2'),
    from: t('landing.review10.fromV2'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/Qez/4rnIZ3wK87cuEDAq2YdqQez/en-US/1/profile10.webp`,
    content: <Trans t={t} i18nKey="landing.review10.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review11.name'),
    from: t('landing.review11.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/6Tg/obfb83wK87duEDAq2YOV6Tg/en-US/1/profile11.webp`,
    content: <Trans t={t} i18nKey="landing.review11.contentV2" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('landing.review12.name'),
    from: t('landing.review12.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/cFM/nmOAm3wK87cuEDAq2VpYcFM/en-US/1/profile12.webp`,
    content: <Trans t={t} i18nKey="landing.review12.contentV2" components={{
      Strong: <StrongText />
    }} />
  }];
  return <section className="flex flex-col items-center gap-2xl px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:gap-3xl min-[1025px]:px-[40px] min-[1025px]:py-3xl" data-sentry-component="Review" data-sentry-source-file="Review.tsx">
      <div className="flex flex-col items-center gap-sm">
        <h2 className="text-center text-display-sm-extrabold text-default min-[751px]:whitespace-normal">
          {t('landing.teacher.title')}
        </h2>
        <p className="text-body-lg-semibold text-neutral">
          {t('landing.teacher.description')}
        </p>
      </div>

      <div className="relative h-[774px] w-full max-w-[1280px] overflow-y-hidden">
        <div className="columns-1 gap-[24px] min-[751px]:columns-3 min-[1025px]:columns-4">
          {REVIEWS.map(review => <ReviewCard key={review.name} {...review} />)}
        </div>
        <div className="absolute bottom-0 h-[100px] w-full bg-gradient-to-b from-[rgba(255,255,255,0)] to-white" />
      </div>

      {locale !== 'ja' && <Button variant="outlined" intent="alternative" size="lg" rightSlot={<ArrowRightIcon fill={ICON_COLOR.strong} size="md" />} onClick={() => {
      logger.track('click_landing_more_reviews_button');
      window.open(locale === 'ko' ? 'https://zep-quiz-teachers-review.super.site/' : 'https://teamzep.notion.site/Global-Reviews-of-ZEP-Quiz-1a789e87fdef8054b98fd02ba9c5b182', '_blank');
    }}>
          {t('landingV3.moreReviews')}
        </Button>}
    </section>;
};
export const ReviewCard = ({
  name,
  from,
  avatarSrc,
  content
}: {
  name: string;
  from: string;
  avatarSrc: string;
  content: JSX.Element;
}) => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <figure className="mx-auto mb-md flex w-full max-w-[500px] break-inside-avoid flex-col gap-md rounded-md border border-alternative px-md py-lg shadow-sm min-[751px]:mb-[24px] min-[751px]:gap-lg min-[751px]:px-lg min-[751px]:py-xl" data-sentry-component="ReviewCard" data-sentry-source-file="Review.tsx">
      <figcaption className="flex items-center gap-xs" data-sentry-element="figcaption" data-sentry-source-file="Review.tsx">
        <img src={avatarSrc} alt={from} className="size-[36px]" loading="lazy" />
        <div className="flex flex-col gap-4xs">
          <span className="text-caption-md-medium text-neutral">{from}</span>
          <span className="text-body-sm-semibold text-neutral">
            {name} {t('landing.review.teacherTitle')}
          </span>
        </div>
      </figcaption>

      <blockquote className="text-body-lg-medium text-neutral">
        {content}
      </blockquote>
    </figure>;
};
const StrongText = ({
  children
}: PropsWithChildren) => <strong className="text-body-lg-bold text-default" data-sentry-component="StrongText" data-sentry-source-file="Review.tsx">{children}</strong>;